var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagFrench(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 30,
    viewBox: "0 0 42 30",
    width: 42,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 30,
    rx: 3,
    width: 42
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 0h11v30h-11c-1.65685425 0-3-1.3431458-3-3v-24c0-1.65685425 1.34314575-3 3-3z",
    fill: "#00299d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 0h11c1.6568542 0 3 1.34314575 3 3v24c0 1.6568542-1.3431458 3-3 3h-11z",
    fill: "#eb000f"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 29,
    rx: 3,
    stroke: "#000",
    strokeOpacity: 0.151879,
    width: 41,
    x: 0.5,
    y: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFrench);
export default __webpack_public_path__ + "static/media/flag_french.17065939bc9f8e8192f43b9e7437e9dc.svg";
export { ForwardRef as ReactComponent };